import React, { Component } from "react";
import { Select } from "antd";
import axios from "axios";

const { Option } = Select;

// Catálogo real (CanalVenta), a diferencia de "canal de distribución" que no existe
// en este ERP. Lista corta -> carga completa una sola vez, sin búsqueda con debounce.
class SelectCanalVentaItem extends Component {
  state = { opciones: [], cargando: false };

  componentDidMount() {
    this.cargarCanalesVenta();
  }

  cargarCanalesVenta = () => {
    this.setState({ cargando: true });
    axios
      .post("canalesVenta/selectCanalesVenta", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ cargando: false });
        if (res.data.success === 2) this.setState({ opciones: res.data.canalesVenta || [] });
      })
      .catch(() => this.setState({ cargando: false }));
  };

  render() {
    const { empresaId, headersToken, ...rest } = this.props;
    return (
      <Select loading={this.state.cargando} showSearch optionFilterProp="children" allowClear {...rest}>
        {this.state.opciones.map((canal) => (
          <Option key={canal._id} value={canal._id}>
            {canal.codigo} - {canal.nombre}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectCanalVentaItem;
